import React from 'react';
import axios from 'axios';
import { Col, Row } from 'reactstrap';
import {getRequestConfig} from 'tunnel-commande/src/utils';
import MenuFaq from "../components/MenuFaq";
import CookieBotContent from '../components/CookieBotContent';
import { Helmet } from 'react-helmet';
import { WithTranslation, withTranslation } from 'react-i18next';
import {HostApiProps, withHostApi} from "../contexts/HostApiContext";
import {RouteProps, withRoute} from "../contexts/RouteContext";
import {ShopInfoProps, withShopInfo} from "../contexts/ShopInfoContext";
import {generateBaseUrl} from "../utils";
import { StaticPageDTO } from '../repositories/static_elements/StaticPageRepository';
import { InitialPropsArgs, StaticPageContextProps } from '../interfaces';


type FaqProps = WithTranslation & HostApiProps & RouteProps & ShopInfoProps & StaticPageContextProps & {context: InitialPropsArgs} & { context: { content?: string; }; };

class Faq extends React.Component<FaqProps, any> {

  private readonly tag: string;
  private readonly staticPage?: StaticPageDTO;

  constructor(props: FaqProps) {
    super(props);

    this.tag = props.route.params['tag'] || '';
    this.staticPage = this.props.context.staticPage;
    this.handleOnSelectChange = this.handleOnSelectChange.bind(this);
    this.state = {
      content: this.props.context.content ?? ''
    };
  }

  componentDidMount(): void {
    if (!this.staticPage) {
      this.loadHtml(this.tag);
    }
  }

  private handleOnSelectChange(endUrl: string) {
    window.location.assign(`/${this.props.i18n.language}${endUrl}`);
  }

  private loadHtml(tag: string) {
    let url = '';

    if(!tag) {
      url = `${window.location.origin}/html/${this.props.i18n.language}/faq.html`;
    } else {
      url = `${window.location.origin}/html/${this.props.i18n.language}/${tag}.html`;
    }

    if(url != '') {

      if (tag === 'conditions-generales-de-vente') {
        url = this.props.hostApi + '/shops/cgv';
      } else if (tag === 'politique-de-confidentialite') {
        url = this.props.hostApi + '/shops/politique-confidentialite';
      } else if (tag === 'politique-generale-de-protection-des-donnees') {
        url = this.props.hostApi + '/shops/politique-generale-protection-des-donnees';
      } else if (tag === 'mentions-legales') {
        url = `${this.props.hostApi}/shops/mentions-legales/lang/${this.props.context.i18n.id}`;
      } else if (tag === 'politique-de-cookies') {
        this.setState({
          content: ' '
        });

        return false;
      }

      axios.get(url, getRequestConfig()).then((res: any) => {
        this.setState({
          content: res.data
        });
      }).catch((err: any) => {
        console.error(err);
      });
    }
  }

  private defineTitle() {
    if (this.staticPage) {
      return this.staticPage.title;
    } else if (this.tag) {
      return this.props.t('title-' + this.tag);
    }

    return this.props.t('title-faq');
  }

  private defineDescription() {
    if (this.staticPage) {
      return this.staticPage.metaDescription;
    } else if (this.tag) {
      return this.props.t('description-' + this.tag);
    }

    return this.props.t('description-faq');
  }

  private defineH1() {
    if (this.staticPage) {
      return this.staticPage.h1;
    } else if (this.tag) {
      return this.props.t('h1-' + this.tag);
    }

    return this.props.t('h1-faq');
  }

  private defineUrl() {
    if (this.tag) { return '/' +  this.tag; }

    return '';
  }

  render() {
    const baseUrl = generateBaseUrl(this.props.shopInfo.env);
    const canonical = `${baseUrl}/${this.props.i18n.language}/faq${this.defineUrl()}`;
    const canonicalFR = `${baseUrl}/fr/faq${this.defineUrl()}`;
    const canonicalEN = `${baseUrl}/en/faq${this.defineUrl()}`;

    return (
      <>
        <Helmet>
          <title>{this.defineTitle()}</title>
          <meta name="description" content={this.defineDescription()} />
          <meta name="twitter:card" content="summary"/>
          <meta name="twitter:site" content="@DuckTransfer"/>
          <meta property="twitter:description" content={this.defineDescription()} />
          <meta property="twitter:title" content={this.defineTitle()} />
          <meta property="og:description" content={this.defineDescription()} />
          <meta property="og:title" content={this.defineTitle()} />
          <meta property="og:site_name" content="DuckTransfer" />
          <meta property="og:locale" content={this.props.i18n.language + '_' + this.props.i18n.language.toUpperCase()} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={canonical} />
          <meta property="og:image" content={`${baseUrl}/images/logo-ducktransfer.jpg`} />
          <meta property="twitter:image" content={`${baseUrl}/images/logo-ducktransfer.jpg`} />
          <link rel="canonical" href={canonical} />
          <link rel="alternate" href={canonicalFR} hrefLang="x-default"/>
          <link rel="alternate" href={canonicalFR} hrefLang="fr"/>
          <link rel="alternate" href={canonicalEN} hrefLang="en"/>
        </Helmet>
        <div className={'container-fluid container-fluid-dt my-5 px-0 py-3 '}>
          <Row className="main-faq-wrapper  mx-0 ml-md-3 mr-md-3">
            <Col xl={{ size: 3 }} lg={{ size: 4 }}  md={{ size: 4 }} className={'pl-lg-0'}>
              {<MenuFaq onChange={this.handleOnSelectChange} tag={this.tag} newFaqIsEnabled={this.props.shopInfo.newFaqIsEnabled} />}
            </Col>
            <Col xl={{ size: 9 }} lg={{ size: 8 }}  md={{ size: 8 }}>
              <h1 className="mt-2 mb-4">{this.defineH1()}</h1>
              <div id={'CookieBotContentWrapper'}>
                <CookieBotContent tag={this.tag} />
              </div>
              {this.tag !== 'politique-de-cookies' &&
              <span dangerouslySetInnerHTML={{__html: this.state.content}}></span>
              }
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

export default withTranslation('faq')(withShopInfo(withRoute(withHostApi(Faq))));
